import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import React, {useContext, useMemo, useState} from 'react'
import {BsCompass, BsFillCalendar2DateFill, BsLightningChargeFill,} from 'react-icons/bs'
import {RiSignalTowerFill} from 'react-icons/ri'
import {FaLightbulb, FaUsers} from 'react-icons/fa6'
import {FaChalkboardTeacher} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import {FlexCol} from 'views/AppLocals/Templates/ItemTemplate'
import renderCategoryLink from 'views/LandingPage/functions/renderCategoryLink'
import {LayoutContext} from '../../../../components/layouts/Default/LayoutContext'
import useTranslate from '../../../../modules/local/useTranslate'
import {useOrgTypeLabel} from '../../../../modules/local/useOrgTypeLabels'
import {getResponseItems, renderIf} from '../../../Shared'
import {isRawContentEmpty} from '../../../SlateEditor/functions/parseRawContent'
import OrganizationContainerContext from '../OrganizationContainerContext'
import Translate from "../../../../modules/local/Translate";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {useToggle} from "react-use";
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import {SiderBlockHeader} from "../components/SiderBlockHeader";
import {SiderBlockCard} from "../components/SiderBlockCard";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {TbBellRingingFilled} from "react-icons/tb";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {announcement_gets_Api, timetable_getDetails_Api} from "../../../../apis";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {Avatar} from "antd";
import {AnnouncementTypes} from "../consts/AnnouncementTypes";
import {useChurches} from "../../Church/functions/useChurches";
import {BiSolidChurch} from "react-icons/bi";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import {OrganizationShopsBlock} from "./OrganizationContactInfo";
import {OrganizationUpcomingEventBlock} from "./OrganizationEventList";
import {PiCalendarCheckFill} from "react-icons/pi";
import dayjs from "dayjs";
import getTitle from "../../../../helpers/getTitle";
import {SlateRenderer} from "../../../SlateEditor";
import {convertFromString} from "../../../SlateEditor/functions";
import {CompletePage, OrganizationSuggest} from "../components/OrganizationSider";
import EmptyHolder from "../../../../components/EmptyHolder";
import {GamePromo, LivestreamMass} from "../../User/components/UserSider";
import OrganizationOpeningCourses from "./OrganizationOpeningCourses";

function renderIntervalWeekly(value) {
    let label = ''
    switch (value) {
        case '1000000':
            label = 'monday'
            break
        case '0100000':
            label = 'tuesday'
            break
        case '0010000':
            label = 'wednesday'
            break
        case '0001000':
            label = 'thursday'
            break
        case '0000100':
            label = 'friday'
            break
        case '0000010':
            label = 'saturday'
            break
        case '0000001':
            label = 'saturday'
            break
        default :
            label = null
            break
    }
    return label ? label : null
}

function renderInterval(value, viewOnly = false) {
    let label
    switch (value) {
        case 'D':
            label = 'daily'
            break
        case 'W':
            label = 'weekly'
            break
        case 'M':
            label = 'monthly'
            break
        default :
            if (viewOnly) return null;
            label = null
            break
    }
    return (
        <Translate>
            {(t) => t(label)}
        </Translate>
    )
}

export const OrganizationUpcomingTimetableBlock = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)

    const {response, isLoading} = useAsync({
        apiInfo: timetable_getDetails_Api,
        values: {owner_type: 'organization', owner_id: organization?.id},
    })

    const items = getResponseItems(response)

    const today = dayjs().startOf('day')
    const endOfTomorrow = dayjs().add(1, 'day').endOf('day')

    const upcoming = _.chain(items || [])
        .filter(e => {
            const st = dayjs(e?.start_time)
            return st.isAfter(today) && st.isBefore(endOfTomorrow) && !dayjs(e?.end_time).isBefore(dayjs())
        })
        .sortBy(e => dayjs(e?.start_time).valueOf())
        .value()

    if (!upcoming.length && !isLoading) return null

    return (
        <SiderBlockCard>
            <SiderBlockHeader
                icon={PiCalendarCheckFill}
                iconBgClassName="bg-secondary-50"
                iconColorClassName="text-secondary-500"
                title={t('upcoming schedule')}
            />
            <div className="flex flex-col gap-3">
                {isLoading ? (
                    <div className="h-10 background-100 rounded-lg animate-pulse"/>
                ) : (
                    upcoming.map((e, i) => {
                        const {start_time, end_time, location_address, notes} = e ?? {}
                        const isToday = dayjs(start_time).isSame(dayjs(), 'day')
                        return (
                            <div key={i} className="flex items-start gap-3 px-2 py-2 rounded-xl border border-indigo-100 bg-indigo-50">
                                <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-indigo-100 flex flex-col items-center justify-center">
                                    <span className="font-extrabold text-sm text-indigo-700 leading-none">
                                        {dayjs(start_time).format('HH:mm')}
                                    </span>
                                    <span className="text-3xs text-indigo-400 mt-0.5">
                                        {isToday ? t('today') : t('tomorrow')}
                                    </span>
                                </div>
                                <div className="flex-1 min-w-0 flex flex-col gap-0.5">
                                    <span className="font-semibold text-sm text-indigo-800 leading-snug">
                                        {getTitle(e)}
                                    </span>
                                    {location_address && (
                                        <span className="text-xs text-color-400 italic">{location_address}</span>
                                    )}
                                    <span className="text-xs text-indigo-400">
                                        {dayjs(start_time).format('HH:mm')} – {dayjs(end_time).format('HH:mm')}
                                    </span>
                                    {notes && (
                                        <span className="text-xs italic text-color-400 max-lines-1">{notes}</span>
                                    )}
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </SiderBlockCard>
    )
}

export const OrganizationIntroduction = ({}) => {

    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)
    const {description} = organization ?? {}
    const history = useHistory()

    if (!description) return null

    return (
        <WrapperBlockSider
            title="charism & mission"
            titleColor="text-indigo-700"
            borderLeft={isLg}
            borderTop={!isLg}
            icon={<FaLightbulb size={18} className="text-indigo-400"/>}>
            <div className="flex flex-col gap-3">
                <div className="text-sm text-color-200 tracking-wide leading-relaxed max-lines-3">
                    {description}
                </div>
                <span
                    className="flex items-center justify-end gap-1 text-color-300 hover:text-color-100 cursor-pointer"
                    onClick={() => {
                        scrollToRow('contentOrg')
                        history.push(getLinkToDetail(organization) + '/overview')
                    }}>
                    <span className="text-xs italic">{t('see more')}</span>
                    <FiChevronsRight size={13} className="my-auto"/>
                </span>
            </div>
        </WrapperBlockSider>
    )
}

// t(key) cho từng thứ trong tuần, index khớp Date.getDay() (0 = Chủ Nhật)
const WEEKDAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

// Tính giờ lễ tiếp theo gần nhất từ association.church.mass_times (dạng đã group theo
// weekdays, kèm children — backend trả sẵn qua ChurchTransformerBasic, không cần gọi thêm API).
// Cài đặt riêng cho card này thay vì import getNextMassTime từ ChurchDetailPage.js vì file đó
// lazy-load kèm map/carousel nặng — import trực tiếp sẽ kéo bundle đó vào mọi trang organization.
function getNextChurchMassTime(groups, t) {
    const now = new Date()

    const toDate = (date, time) => {
        const [h, m] = (time || '').split(':')
        const x = new Date(date)
        x.setHours(+h || 0, +m || 0, 0, 0)
        return x
    }

    const isMatchWeekday = (weekdays, date) => weekdays?.[date.getDay()] === '1'
    const getGroupByDate = (date) => (groups || []).find((g) => isMatchWeekday(g.weekdays, date))

    const findNextTimeToday = (group, date) =>
        group?.children
            ?.map((i) => ({time: i.start_time, dt: toDate(date, i.start_time)}))
            .filter((i) => i.dt > now)
            .sort((a, b) => a.dt - b.dt)[0]?.time

    const firstTime = (group) =>
        (group?.children || [])
            .map((i) => i.start_time)
            .filter(Boolean)
            .sort()[0]

    // Hôm nay hết lễ thì dò tiếp tới 6 ngày sau (thứ 7, chủ nhật...) thay vì chỉ dừng ở ngày mai —
    // nhà thờ có thể chỉ có lễ vào cuối tuần.
    for (let offset = 0; offset <= 6; offset++) {
        const targetDate = new Date(now)
        targetDate.setDate(now.getDate() + offset)

        const group = getGroupByDate(targetDate)
        const time = offset === 0 ? findNextTimeToday(group, targetDate) : firstTime(group)
        if (!time) continue

        const label = time.slice(0, 5)
        if (offset === 0) return label
        if (offset === 1) return `${label} (${t('tomorrow')})`
        return `${label} (${t(WEEKDAY_KEYS[targetDate.getDay()])})`
    }

    return ''
}

export const OrganizationChurchOrAnnouncement = () => {

    const {isLg} = useContext(LayoutContext)
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)
    const {association} = organization ?? {}
    const {church} = association ?? {}
    const [isToggle, toggle] = useToggle()

    const nextMassTime = useMemo(
        () => getNextChurchMassTime(association?.church?.mass_times, t),
        [association?.church?.mass_times, t]
    )

    const {response} = useAsync({
        apiInfo: announcement_gets_Api,
        values: {owner_type: 'organization', owner_id: organization?.id, status: 1}
    })
    const announcements = getResponseItems(response)
    const hasMore = Number(announcements?.length) > 2
    const visibleAnnouncements = (announcements || []).slice(0, isToggle ? Number(announcements?.length) : 2)

    const {churchModal, showDialog} = useChurches({notifyListeners: {}})

    // Component này render ở 2 chỗ khác nhau: sidebar desktop (OrganizationSider.js, luôn isLg=true -
    // cần khung thẻ riêng biệt hẳn, không gộp chung khung với khối khác) VÀ trong dòng nội dung chính
    // trên mobile (OrganizationInfo.js bên dưới, isLg=false - hoà vào trang, KHÔNG cần khung/bóng đổ
    // riêng). Chọn Wrapper theo isLg thay vì luôn ép SiderBlockCard, tránh vô tình thêm khung thẻ lạc
    // chỗ ở bản mobile.
    const Wrapper = isLg ? SiderBlockCard : 'div'

    return (church || Number(announcements?.length) > 0) && (
        <Wrapper className={!isLg ? 'w-full flex flex-col gap-3' : undefined}>
            <SiderBlockHeader
                icon={TbBellRingingFilled}
                iconBgClassName="bg-blue-100"
                iconColorClassName="text-blue-500"
                title={t('announcements')}
            />
            <div className="flex flex-col gap-3">
                {/* Church row */}
                {church && (
                    <div className="flex items-center gap-2">
                        <Avatar
                            size={50}
                            src={association?.church?.photo}
                            icon={<BiSolidChurch size={22} className="text-indigo-500"/>}
                            className="flex flex-center bg-indigo-50 rounded-xl"
                        />
                        <div className="flex flex-col flex-1">
                            <Link to={getLinkToDetail(church)} className="no-underline">
                                <p className="font-bold text-base text-color-000 tracking-wide">
                                    {association?.church?.name}
                                </p>
                            </Link>
                            {nextMassTime && (
                                <p className="font-medium text-2xs text-slate-500 tracking-wider leading-none">
                                    {`${t('next mass time')}: `}
                                    <span className="font-mono font-bold text-sm text-primary-700 tracking-tight">
                                        {nextMassTime}
                                    </span>
                                </p>
                            )}
                            <div className="mt-0.5 flex items-center justify-end gap-1 text-color-300 hover:text-blue-700 cursor-pointer">
                                <span
                                    onClick={() => showDialog(church)}
                                    className="text-xs tracking-wider">
                                    {t('see more mass time')}
                                </span>
                                <FiChevronsRight size={13} className="my-auto"/>
                            </div>
                        </div>
                    </div>
                )}
                {/* Divider chỉ khi có cả church lẫn announcements */}
                {church && Number(announcements?.length) > 0 && (
                    <div className="border-b border-dashed"/>
                )}
                {/* Announcement list — không lặp header mỗi item */}
                {Number(visibleAnnouncements.length) > 0 && (
                    <div className="flex flex-col gap-3">
                        {visibleAnnouncements.map((e, i) => {
                            const typeItem = _.find(AnnouncementTypes, {value: e?.type_code || e?.type_label})
                            return (
                                <DrawDialog
                                    key={i}
                                    width={600}
                                    title={
                                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                            {t('announcements')}
                                        </div>
                                    }
                                    closable={true}
                                    component={
                                        <div
                                            key={i}
                                            className="px-3 py-2 flex flex-col background md:background-50 hover:shadow-md hover:scale-2xs rounded-xl cursor-pointer">
                                            {/* Type badge — nhỏ gọn, không uppercase to */}
                                            <div className="mb-1 flex items-center gap-1">
                                                {typeItem?.icon}
                                                <span className="text-xs font-semibold text-blue-600 tracking-wide">
                                                    {e?.type_label}
                                                </span>
                                            </div>
                                            {/* Title — bỏ uppercase, dễ đọc hơn */}
                                            <span className="font-bold text-sm text-color-000 hover:text-primary tracking-wide leading-snug">
                                                {e?.title}
                                            </span>
                                            <div className="mt-1 text-xs text-color-300 tracking-wider whitespace-pre-line max-lines-2">
                                                {e?.content}
                                            </div>
                                        </div>
                                    }>
                                    {(isToggle, toggle) => isToggle && (
                                        <div className="flex flex-col gap-4">
                                            <div className="flex flex-col gap-3">
                                                <div className="flex flex-col gap-1">
                                                    <span className="font-medium text-color-200 tracking-wide">
                                                        {t('title')}
                                                    </span>
                                                    <span className="ml-3 font-bold text-lg text-gray-700 tracking-wide">
                                                        {e?.title}
                                                    </span>
                                                    {e?.type && (
                                                        <span className="ml-3 font-semibold text-sm text-blue-700 italic tracking-wide">
                                                            {t(e?.type)}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                                    <span className="font-medium text-color-200 tracking-wide">
                                                        {t('content')}
                                                    </span>
                                                    <div
                                                        className="ml-3 text-color-300 tracking-wider whitespace-pre-line">
                                                        {e?.content}
                                                    </div>
                                                    {e?.shared_url && (
                                                        <Link
                                                            to={getLinkToDetail(e?.shared_url)}
                                                            target="_blank"
                                                            className="ml-3 text-color-200 italic no-underline">
                                                            {e?.shared_url}
                                                        </Link>
                                                    )}
                                                    {(e?.time_open || e?.time_close) && (
                                                        <DoubleValueItem
                                                            showIcon={true}
                                                            labelFirst={t('from date')}
                                                            valueFirst={formatSimplifyDate(e?.time_open, 'medium')}
                                                            labelSecond={t('to date')}
                                                            valueSecond={formatSimplifyDate(e?.time_close, 'medium')}
                                                            className="ml-3 text-sm"
                                                        />
                                                    )}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                                    <span className="font-medium text-color-200 tracking-wide">
                                                        {t('send at')}
                                                    </span>
                                                    <span className="ml-3 text-color-300 tracking-wider italic">
                                                        {formatSimplifyDate(e?.created, 'fullTime')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </DrawDialog>
                            )
                        })}

                        {/* Chỉ hiển thị "Xem thêm/ít" khi có hơn 2 item */}
                        {hasMore && (
                            <span
                                className="flex items-center justify-end gap-1 text-color-300 hover:text-color-100 cursor-pointer"
                                onClick={() => toggle()}>
                                <span className="text-xs tracking-wider">
                                    {isToggle ? t('see less') : t('see more')}
                                </span>
                                <FiChevronsRight size={13} className="my-auto"/>
                            </span>
                        )}
                    </div>
                )}
                {churchModal}
            </div>
        </Wrapper>
    )
}

// Visitor thường (không có quyền edit) không thấy CompletePage (checklist nhập liệu chỉ dành cho
// admin/QTV, xem OrganizationSider.js) — nếu tổ chức đã có nội dung ở tab khác (Sự kiện/Kênh/Nhóm/
// Khóa học), dẫn sang tab đó thay vì để trống hẳn chỗ này. Không có CTA "thêm/sửa" vì visitor không
// sửa được. Nếu tổ chức không có gì ở bất kỳ tab nào, không render gì (EmptyHolder chung ở đầu trang
// đã xử lý ca "trống hoàn toàn"), tránh 2 thông điệp trống chồng nhau.
const OrganizationExploreTabsTeaser = ({organization}) => {
    const t = useTranslate()
    const base = getLinkToDetail(organization)
    const deptLabel = useOrgTypeLabel(organization?.org_type, 'group', organization?.label_privacy) || t('groups / ministries')
    const courseCount = organization?.workspace_settings?.courses?.statistics?.course_count

    const items = [
        Number(organization?.total_events) > 0 && {
            key: 'events', to: `${base}/events`,
            Icon: BsFillCalendar2DateFill, iconClass: 'text-green-500',
            label: t('view events'),
        },
        Number(organization?.total_channels) > 0 && {
            key: 'channels', to: `${base}/channels`,
            Icon: RiSignalTowerFill, iconClass: 'text-blue-600',
            label: t('explore channels'),
        },
        Number(organization?.groups?.length) > 0 && {
            key: 'groups', to: `${base}/groups`,
            Icon: FaUsers, iconClass: 'text-secondary-500',
            label: deptLabel,
        },
        Number(courseCount) > 0 && {
            key: 'courses', to: `${base}/courses`,
            Icon: FaChalkboardTeacher, iconClass: 'text-green-500',
            label: t('courses'),
        },
    ].filter(Boolean)

    if (!items.length) return null

    // Trước dùng GroupEmptyState (icon 56px + tiêu đề CANH GIỮA, py-12) - đúng component "trạng thái
    // trống" (không có gì để hiện), nhưng đây KHÔNG PHẢI trạng thái trống - đây là gợi ý điều hướng
    // (đã có nội dung ở tab khác). Mượn đúng pattern "suggestion module" của Twitter/X: card đặc,
    // icon nhỏ + text CANH TRÁI nằm ngang 1 hàng, chip hành động gọn ngay dưới - dày dặn thông tin
    // hơn hẳn, không để trống trải như 1 trang lỗi/rỗng.
    return (
        <div className="p-4 flex items-start gap-3 background-50 rounded-2xl">
            <div
                className="flex-shrink-0 flex flex-center rounded-full bg-secondary-100 text-secondary-600"
                style={{width: 36, height: 36}}>
                <BsCompass size={17}/>
            </div>
            <div className="flex-1 min-w-0 flex flex-col gap-2">
                <span className="font-bold text-sm text-color-000 leading-snug">
                    {t('discover more about this organization')}
                </span>
                <div className="flex flex-wrap gap-2">
                    {items.map(({key, label, to, Icon, iconClass}) => (
                        <Link
                            key={key}
                            to={to}
                            className="flex items-center gap-1.5 px-3 py-1.5 background border border-color-100 hover:border-secondary-300 hover:background-50 rounded-full text-xs font-semibold text-color-100 no-underline transition-colors">
                            <Icon size={14} className={iconClass}/>
                            {label}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    )
}

const OrganizationInfo = ({Wrapper = FlexCol}) => {
    const {organization} = useContext(OrganizationContainerContext)
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const [isToggle, toggle] = useToggle(true)
    const [expandedAbout, setExpandedAbout] = useState(false)

    const {about, description, categories = [], association} = organization ?? {}


    const nextMassTime = useMemo(
        () => getNextChurchMassTime(association?.church?.mass_times, t),
        [association?.church?.mass_times, t]
    )


    const {churchModal, showDialog} = useChurches({notifyListeners: {}})

    if (_.isEmpty(organization)) return null

    return (
        <Wrapper className="items-start gap-6 pb-20">

            {/* Church row */}
            {(!isLg && association?.church) && (
                <div className="w-full p-3 background shadow-sm rounded-2xl flex items-start gap-2">
                    <Avatar
                        size={50}
                        src={association?.church?.photo}
                        icon={<BiSolidChurch size={22} className="text-indigo-500"/>}
                        className="flex flex-center bg-indigo-50 rounded-xl"
                    />
                    <div className="flex flex-col flex-1">
                        <Link to={getLinkToDetail(association?.church)} className="no-underline">
                            <p className="font-bold text-base text-color-000 tracking-wide">
                                {association?.church?.name}
                            </p>
                        </Link>
                        {nextMassTime && (
                            <p className="font-medium text-2xs text-slate-500 tracking-wider leading-none">
                                {`${t('next mass time')}: `}
                                <span className="font-mono font-bold text-sm text-primary-700 tracking-tight">
                                    {nextMassTime}
                                </span>
                            </p>
                        )}
                        <div className="mt-1.5 flex items-center justify-end gap-1 text-color-300 hover:text-blue-700 cursor-pointer">
                                <span
                                    onClick={() => showDialog(association?.church)}
                                    className="text-xs tracking-wider">
                                    {t('see more mass time')}
                                </span>
                            <FiChevronsRight size={13} className="my-auto"/>
                        </div>
                    </div>
                </div>
            )}

            {churchModal}

            {renderIf(
                (!description && !about && (!categories || categories.length === 0)),
                <EmptyHolder subTitle={t('organization miss information')}/>
            )}

            {/* Categories */}
            {Number(categories?.length) > 0 && (
                <div className="flex flex-wrap gap-2">
                    {categories.map(renderCategoryLink)}
                </div>
            )}

            {description && (
                <div className="w-full flex flex-col background shadow-sm rounded-xl">
                    <div
                        style={{ backgroundImage: 'linear-gradient(to right, rgb(43, 108, 176), rgb(49, 130, 206))' }}
                        className="p-3 flex items-center gap-2 rounded-t-xl">
                        <div className="p-2 flex flex-center background rounded-lg">
                            <BsLightningChargeFill size={18} className="text-blue-700"/>
                        </div>
                        <div className="flex flex-col flex-1 min-w-0">
                            <h3 className="font-bold text-sm text-white uppercase tracking-wide leading-snug">
                                {t('charism & mission')}
                            </h3>
                            <div style={{ height: 4 }} className="w-20 mt-1 rounded-full bg-white-60"/>
                        </div>
                    </div>
                    <div className="p-3 border-t border-color-200 text-base text-color-100 tracking-wide leading-relaxed">
                        {description}
                    </div>
                </div>
            )}

            {!isRawContentEmpty(about) && (
                <div style={{fontSize: 13}}>
                    <SlateRenderer
                        value={convertFromString(about)}
                    />
                </div>
            )}

            {/*{!isLg && <OrganizationChurchOrAnnouncement/>}*/}
            {!isLg && <OrganizationUpcomingTimetableBlock/>}
            {!isLg && <OrganizationOpeningCourses/>}
            {!isLg && <OrganizationUpcomingEventBlock/>}
            {!isLg && <OrganizationShopsBlock/>}

            {!isLg && <OrganizationSuggest/>}
            {!isLg && <LivestreamMass/>}
            {!isLg && <GamePromo/>}
            {(!description || !about || (!categories || categories.length === 0)) && (
                organization?.edit
                    ? <CompletePage organization={organization}/>
                    : (isLg && <OrganizationExploreTabsTeaser organization={organization}/>)
            )}

        </Wrapper>
    )
}

export default OrganizationInfo
